/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const FONTS = {
    "Montserrat-Bold": require('./res/fonts/Montserrat-Bold.ttf'),
    "Montserrat-Light": require('./res/fonts/Montserrat-Regular.ttf'),
    "Montserrat-Medium": require('./res/fonts/Montserrat-Medium.ttf'),
    "Montserrat-Regular": require('./res/fonts/Montserrat-Regular.ttf'),
    "Roboto-Bold": require('./res/fonts/Roboto-Bold.ttf'),
    "Roboto-Light": require('./res/fonts/Roboto-Light.ttf'),
    "Roboto-Medium": require('./res/fonts/Roboto-Medium.ttf'),
    "Roboto-Regular": require('./res/fonts/Roboto-Regular.ttf'),
    "Conthrax-sb": require('./res/fonts/conthrax-sb.ttf'),
};
